"use client"

import IconFont from "../../IconFont"
import styles from "./index.module.scss"

export default function BackToTop() {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    })
  }

  return (
    <div className={styles.container} onClick={scrollToTop}>
      <IconFont
        type="icon-Union"
        className={styles.icon}
        style={{
          width: "auto",
          height: "auto",
          fontSize: "16px",
        }}
      />
    </div>
  )
}
